import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY
const SUPABASE_RETRY_BASE_MS = 750
const SUPABASE_MAX_RETRIES = 3

const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms))

const isRetryableSupabaseStatus = (status) => [500, 502, 503, 504].includes(Number(status))

const isRetryableSupabaseError = (error) => {
  const message = String(error?.message || '').toLowerCase()
  return (
    error?.name === 'TypeError' ||
    message.includes('failed to fetch') ||
    message.includes('network') ||
    message.includes('name_not_resolved')
  )
}

const supabaseFetchWithRetry = async (input, init) => {
  let lastError

  for (let attempt = 0; attempt <= SUPABASE_MAX_RETRIES; attempt += 1) {
    try {
      const response = await fetch(input, init)

      if (attempt < SUPABASE_MAX_RETRIES && isRetryableSupabaseStatus(response.status)) {
        await sleep(SUPABASE_RETRY_BASE_MS * Math.pow(2, attempt))
        continue
      }

      return response
    } catch (error) {
      lastError = error

      if (attempt >= SUPABASE_MAX_RETRIES || !isRetryableSupabaseError(error)) {
        throw error
      }

      await sleep(SUPABASE_RETRY_BASE_MS * Math.pow(2, attempt))
    }
  }

  throw lastError
}

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase configuration is missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY environment variables')
}

export const supabase = createClient(supabaseUrl || '', supabaseAnonKey || '', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  },
  global: {
    fetch: supabaseFetchWithRetry
  }
})

